// src/components/about/DoctorCard.jsx
import React from 'react';
import { motion } from 'framer-motion';

const DoctorCard = ({ name, role, image, education, specialization, description }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-50px' }}
      transition={{ duration: 0.5 }}
      className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-2xl transition-all duration-500 group border border-gray-100"
    >
      {/* Image with zoom and overlay */}
      <div className="relative overflow-hidden">
        <img
          src={image}
          alt={name}
          className="w-full h-72 object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        {/* Name overlay on hover */}
        <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-500">
          <p className="text-white font-bold text-lg">{name}</p>
          <p className="text-blue-200 text-sm">{role}</p>
        </div>
      </div>

      {/* Blue accent bar */}
      <div className="h-1 bg-gradient-to-r from-blue-500 to-blue-300" />

      <div className="p-6">
        <h3 className="text-xl font-bold text-gray-900">{name}</h3>
        <p className="text-blue-600 font-medium text-sm mt-1">{role}</p>
        <div className="mt-3 space-y-1.5">
          <p className="text-sm text-gray-500 flex items-start">
            <span className="font-semibold text-gray-700 mr-1.5 flex-shrink-0">Education:</span> {education}
          </p>
          <p className="text-sm text-gray-500 flex items-start">
            <span className="font-semibold text-gray-700 mr-1.5 flex-shrink-0">Specialization:</span> {specialization}
          </p>
        </div>
        <p className="mt-3 text-gray-500 text-sm leading-relaxed">{description}</p>
      </div>
    </motion.div>
  );
};

export default DoctorCard;